function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  background-color: #eff9f2;\n  border: 1px solid #bfded2;\n  border-radius: 4px;\n  color: #6d8d76;\n  font-size: 12px;\n  line-height: 1.5;\n  padding: 8px 14px 8px 14px;\n  ",
        "\n  b {\n    font-weight: bold;\n  }\n\n  &.yellow {\n    border: solid 1px #d8d5ba;\n    background-color: #fffdeb !important;\n    color: #75725b;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { Box } from 'rebass/styled-components';
import styled from 'styled-components';
import { space } from 'styled-system';
export default styled(Box)(_templateObject(), space);
